import { useState, useEffect, useRef } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './baseNode';

const extractVariables = (text) => {
  const regex = /\{\{\s*([a-zA-Z_$][a-zA-Z0-9_$]*)\s*\}\}/g;
  const vars = [];
  let match;
  while ((match = regex.exec(text)) !== null) {
    if (!vars.includes(match[1])) vars.push(match[1]);
  }
  return vars;
};

export const TextNode = ({ id, data }) => {
  const [currText, setCurrText] = useState(data?.text || '{{input}}');
  const [nodeSize, setNodeSize] = useState({ width: 220, height: 'auto' });
  const textareaRef = useRef(null);

  // Auto-resize when text changes
  useEffect(() => {
    if (!textareaRef.current) return;
    // Reset height to auto first to shrink correctly
    textareaRef.current.style.height = 'auto';
    const scrollH = textareaRef.current.scrollHeight;
    const newWidth = Math.max(220, Math.min(500, currText.length * 7 + 60));
    const newHeight = Math.max(60, scrollH);
    textareaRef.current.style.height = newHeight + 'px';
    setNodeSize({ width: newWidth });
  }, [currText]);

  const variables = extractVariables(currText);

  // One left-side target Handle per {{variable}}, evenly spaced
  const varHandles = variables.map((v, i) => ({
    type: 'target',
    position: Position.Left,
    id: `${id}-${v}`,
    style: { top: `${((i + 1) / (variables.length + 1)) * 100}%` },
  }));

  const outputHandle = [
    { type: 'source', position: Position.Right, id: `${id}-output` },
  ];

  return (
    <BaseNode
      label="Text"
      color="#f59e0b"
      handles={[...varHandles, ...outputHandle]}
      width={nodeSize.width}
    >
      {/* Show variable labels on the left so user knows what connects where */}
      {variables.length > 0 && (
        <div style={{ marginBottom: 6 }}>
          {variables.map((v, i) => (
            <div
              key={v}
              style={{
                fontSize: 10,
                color: '#d97706',
                fontWeight: 600,
                paddingLeft: 4,
                marginTop: i > 0 ? 4 : 0,
              }}
            >
              ← {v}
            </div>
          ))}
        </div>
      )}

      {/* Text input area */}
      <div style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 3 }}>
        Text
      </div>
      <textarea
        ref={textareaRef}
        value={currText}
        onChange={(e) => setCurrText(e.target.value)}
        placeholder="Type text or use {{variable}}"
        rows={2}
        style={{
          width: '100%',
          padding: '5px 8px',
          border: '1px solid #e2e8f0',
          borderRadius: 5,
          fontSize: 12,
          color: '#1e293b',
          background: '#fffbeb',
          outline: 'none',
          boxSizing: 'border-box',
          resize: 'none',
          lineHeight: 1.5,
          fontFamily: 'inherit',
          overflow: 'hidden',
        }}
      />
      {variables.length > 0 && (
        <div style={{ fontSize: 10, color: '#92400e', background: '#fef3c7', borderRadius: 4, padding: '3px 6px' }}>
          {variables.length} variable{variables.length > 1 ? 's' : ''} detected
        </div>
      )}
    </BaseNode>
  );
};